// Copyright 2021-2022 zcloak authors & contributors
// SPDX-License-Identifier: Apache-2.0

import { Box, Container as MuiContainer, Stack, styled } from '@mui/material';
import { Link } from 'react-router-dom';

import IconDiscord from './icon_discord.svg';
import IconGithub from './icon_github.svg';
import IconTwitter from './icon_twitter.svg';
import LogoZcloakBlack from './logo_zcloak_black.svg';
import LogoZcloakfontBlack from './logo_zcloakfont_black.svg';

const Wrapper = styled(Box)({
  borderTop: '1px solid #707070'
});

const Container = styled(MuiContainer)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  height: 160
});

function Footer() {
  return (
    <Wrapper>
      <Container>
        <Stack component={Link} direction="row" spacing={2} to="/">
          <img src={LogoZcloakBlack} style={{ width: 40 }} />
          <img src={LogoZcloakfontBlack} style={{ width: 240 }} />
        </Stack>
        <Stack direction="row" spacing={2}>
          <Box component="a" href="https://twitter.com/zcloaknetwork" target="_blank">
            <img src={IconTwitter} />
          </Box>
          <Box component="a" href="https://discord.com/invite/j3mATwNVSH" target="_blank">
            <img src={IconDiscord} />
          </Box>
          <Box component="a" href="https://github.com/zCloak-Network" target="_blank">
            <img src={IconGithub} />
          </Box>
        </Stack>
      </Container>
    </Wrapper>
  );
}

export default Footer;
